/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

// @ts-nocheck TS2339
import styled from 'styled-components';

import { Sidebar } from 'primitives';

const FOOTER_HEIGHT = 39;

export const SidebarSection = styled(Sidebar.Section)`
  width: 350px;
  height: ${({ $isHalfHeight }) =>
    $isHalfHeight ? `calc(50% - ${FOOTER_HEIGHT}px)` : `calc(100% - ${FOOTER_HEIGHT}px)`};
`;
